module.exports = new __parcel__URL__("Mageskill_34.44210f4a.png").toString();